export const isDateBetween = (date: Date, startDate: Date, endDate: Date): boolean => {
    return date.getTime() >= startDate.getTime() && date.getTime() <= endDate.getTime();
};
